import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '1',
      name: i18n.t('tipos.alerta.critical'),
      alertType: 'error',
    },
    {
      id: '2',
      name: i18n.t('tipos.alerta.error'),
      alertType: 'error',
    },
    {
      id: '3',
      name: i18n.t('tipos.alerta.warning'),
        
    },
    {
      id: '4',
      name: i18n.t('tipos.alerta.info'),
      alertType: 'info',
    },
    {
      id: '5',
      name: i18n.t('tipos.alerta.success'),
      alertType: 'success',
    },
  ]
}

function GenerateConfigEstadoAlerta () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.alerta.critical'),
      alertType: 'error',
    },
    {
      id: 2,
      name: i18n.t('avisos.singular_header'),
      alertType: 'warning',
    },
    {
      id: 3,
      name: i18n.t('tipos.alerta.info'),
      alertType: 'info',
    },
  ]
}

export function TIPOS_ALERTA (state) {
  return configHelper.getConfig(state, 'TIPOS_ALERTA', GenerateConfig)
}

export function TIPOS_ALERTA_ESTADO (state) {
  return configHelper.getConfig(state, 'TIPOS_ALERTA_ESTADO', GenerateConfigEstadoAlerta)
}
